import { delay, http, HttpResponse } from 'msw';
import { IGetTruckerTypeReturn } from 'services/trucker';
import { mockRecommendedTruckersResponse } from './truckerRecommendedMock';

const truckerRecommended = [
  http.get(`${process.env.TRUCKER_RECOMMENDATION_BFF_URL}freights/:id/truckers-recommendation`, async () => {
    await delay(1500);

    return HttpResponse.json<IGetTruckerTypeReturn>(mockRecommendedTruckersResponse);
  }),
];

export { truckerRecommended };
